import React,{Component} from 'react'
import firebase from '../helper/firebase'

import {
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
} from 'material-ui'

import DeleteIcon from 'material-ui-icons/Delete'

const stars = [
  '★☆☆☆☆','★★☆☆☆','★★★☆☆','★★★★☆','★★★★★'
]

export default class SkillsList extends Component{
  handleDelete=(skill)=>{
    const {uid} = this.props;
    firebase.firestore().collection('skills').doc(uid).update({
      [`${skill.sid}`]: firebase.firestore.FieldValue.delete()
    })
    .then(()=>{
      console.log(`deleted ${skill.sid}`);
    })
    .catch(error=>console.log(error))
  }

  render(){
    const {skills} = this.props;
    return(
      <List>
        {Object.keys(skills)
        .map(sid=>skills[sid])
        .map((skill,i)=>{
          return (
            <div
              key={i}
            >
              <ListItem>
                <ListItemText style={{color:'blue'}} primary={`${skill.name_display}  |  ${stars[skill.level-1]}  |  ${skill.years} ${skill.years===1 ? 'year' : 'years'}`} />
                <ListItemSecondaryAction>
                  <IconButton onClick={()=>{this.handleDelete(skill)}} aria-label="Delete">
                    <DeleteIcon />
                  </IconButton>
                </ListItemSecondaryAction>
              </ListItem>
              <Divider light />
            </div>
          )
        })}
      </List>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/SkillsList.js